import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Button from 'react-bootstrap/Button'

const ScreenLink = styled(Link)`
  display: block;
  height: ${props => props.height};
  border-radius: ${props => props.borderradius};
  border: none;
  background: ${props => props.background};
  width: ${props => props.width};
  margin: 0 auto 0.625em;
  padding-top: 0.9em;
  padding-bottom: 0.8em;
  &:hover {
    text-decoration: none;
  }
`
const ScreenButton = styled(Button)`
  display: block;
  height: ${props => props.height};
  border-radius: ${props => props.borderradius};
  border: none;
  background: ${props => props.background};
  width: ${props => props.width};
  margin: 0 auto 0.625em;
  padding-top: ${props => props.top};
  padding-bottom: 0.8em;
  box-shadow: ${props => props.shadow};
`
const Text = styled.p`
  font-size: ${props => props.textSize};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: ${props => props.align};
  color: ${props => props.textColor};
  padding-${props => props.theme.reverseDir}: ${props => props.left};
`
export default function ActiveButton(props) {
  const {
    handleSubmit,
    disabled,
    text,
    background,
    textColor,
    path,
    borderRadius,
    width,
    textSize,
    height,
    align,
    left,
    shadow,
    top,
  } = props
  // console.log('path:', path)
  if (path === '/') {
    return (
      <ScreenButton
        onClick={handleSubmit}
        disabled={disabled}
        background={background}
        borderradius={borderRadius}
        width={width}
        height={height}
        shadow={shadow}
        top={top}
      >
        <Text
          textColor={textColor}
          textSize={textSize}
          align={align}
          left={left}
        >
          {text}
        </Text>
      </ScreenButton>
    )
  } else {
    return (
      <ScreenLink
        onClick={handleSubmit}
        disabled={disabled}
        background={background}
        borderradius={borderRadius}
        width={width}
        to={path}
        height={height}
      >
        <Text textColor={textColor} textSize={textSize} align={align}>
          {text}
        </Text>
      </ScreenLink>
    )
  }
}

ActiveButton.propTypes = {
  handleSubmit: PropTypes.func,
  disabled: PropTypes.bool,
  text: PropTypes.any,
  textColor: PropTypes.string,
  textSize: PropTypes.string,
  background: PropTypes.string,
  path: PropTypes.any,
  borderRadius: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  align: PropTypes.string,
  left: PropTypes.string,
  shadow: PropTypes.string,
  top: PropTypes.string,
}

ActiveButton.defaultProps = {
  borderRadius: '0.16em',
  width: '100%',
  path: '/',
  textSize: '1em',
  height: '3em',
  align: 'center',
  left: 'center',
  shadow: '0 0 0 0',
  top: '0.9em',
}
